import styled from 'styled-components';

export const ModalBodyContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  align-items: center;
`;

export const MessageText = styled.div`
  display: flex;
  width: 100%;
  text-align: center;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 24px;
`;

export const CheckboxContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
  width: 100%;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  
  &:hover {
    opacity: 0.8;
  }
`;

/** Evita doble toggle: el Checkbox dispara onChange y el clic subiría al CheckboxContainer. */
export const CheckboxHitArea = styled.span`
  display: inline-flex;
  align-items: center;
  line-height: 0;
`;

export const FieldContainer = styled.div`
  display: flex;
  max-width: 500px;
  width: 300px;
  flex-direction: row;
`;

